document.addEventListener('DOMContentLoaded', function () {
  const wishlistButtons = document.querySelectorAll('.WishlistButton');

  wishlistButtons.forEach(button => {
    const handle = button.dataset.productHandle;

    // Отметить активные
    if (isInWishlist(handle)) {
      button.classList.add('is-active');
    }

    button.addEventListener('click', () => {
      toggleWishlist(handle);
      button.classList.toggle('is-active');
    });
  });

  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }
});